module.exports = __webpack_public_path__ + "static/media/activity.39cc53ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/activity.png
// module id = 7470
// module chunks = 0